import { verify } from "specified";
import { ResponseError } from "./response-error.js";
const okOrThrow = (response) => {
  if (!response.ok) {
    const error = new ResponseError(
      `Request to ${response.url} failed: ${response.status} - ${response.statusText}.`,
      response.status
    );
    throw error;
  }
};
async function okOrThrowWithResponseError(response, responseMapper) {
  if (response.ok) {
    return;
  }
  let isHandled = false;
  try {
    const result = await response.json();
    const error = new ResponseError(result.message, response.status, responseMapper?.(result));
    isHandled = true;
    throw error;
  } catch (error) {
    if (isHandled) {
      throw error;
    }
    okOrThrow(response);
  }
}
const unwrapResponse = async (response, options = {}) => {
  if (response.status === 422) {
    return response.json().then((error) => {
      throw error;
    });
  }
  if (options.useResponseError || options.responseErrorMapper) {
    await okOrThrowWithResponseError(response, options.responseErrorMapper);
  } else {
    await okOrThrow(response);
  }
  return await response.json();
};
const validateResponse = async (spec, response) => {
  okOrThrow(response);
  const { err, value } = verify(spec, await response.json());
  if (err) {
    throw err;
  }
  return value();
};
export {
  okOrThrow,
  unwrapResponse,
  validateResponse
};
//# sourceMappingURL=response.js.map
